module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Barthelemy-22388b441bf56d9dce5a1c1f0a1ce9ae.png";